var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoading
    ? _c("KioskCenteredLayout", [_c("KioskSpinner")], 1)
    : _c(
        "div",
        [
          _c("KioskMenuHeader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowHeader(_vm.$router.currentRoute),
                expression: "isShowHeader($router.currentRoute)"
              }
            ],
            class: _vm.$style.header,
            attrs: {
              "is-menu-header": _vm.isShowMenuHeader(_vm.$router.currentRoute)
            }
          }),
          _vm._v(" "),
          _vm._t("default"),
          _vm._v(" "),
          _c("Cart", {
            attrs: { display: _vm.showCart, "current-page": _vm.$route.name },
            on: {
              closeCart: function($event) {
                return _vm.setCartDisplay(false)
              },
              checkout: _vm.handleCheckout
            }
          }),
          _vm._v(" "),
          _vm.modalInfo("goToMenuOrMain") === "menu"
            ? _c("KioskConfirmMessage", {
                attrs: {
                  title: "Abandon boss creation?",
                  "confirm-text": "Yes, abandon",
                  "cancel-text": "No, keep creating"
                },
                on: {
                  cancel: function($event) {
                    return _vm.modalUpdate({ name: "goToMenuOrMain" })
                  },
                  confirm: _vm.redirectToMenu
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalInfo("cartOrderCancel")
            ? _c("KioskConfirmMessage", {
                attrs: {
                  title: "Cancel your entire order?",
                  "confirm-text": "Yes, cancel",
                  "cancel-text": "No"
                },
                on: {
                  cancel: function($event) {
                    return _vm.modalUpdate({ name: "cartOrderCancel" })
                  },
                  confirm: _vm.cancelOrder
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalInfo("cartItemEdit")
            ? _c("KioskConfirmMessage", {
                attrs: {
                  title: "Abandon boss creation?",
                  "confirm-text": "Yes, abandon",
                  "cancel-text": "No, keep creating"
                },
                on: {
                  cancel: function($event) {
                    return _vm.modalUpdate({ name: "cartItemEdit" })
                  },
                  confirm: _vm.handleEditItem
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.modalInfo("cartItemRemove")
            ? _c("KioskConfirmMessage", {
                attrs: {
                  title: "Remove item from your order?",
                  "confirm-text": "Yes, remove item",
                  "cancel-text": "Keep item"
                },
                on: {
                  cancel: function($event) {
                    return _vm.modalUpdate({ name: "cartItemRemove" })
                  },
                  confirm: _vm.handleRemoveItem
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ApiErrors")
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/KioskLayout.vue?vue&type=template&id=0751b604&
// module id = null
// module chunks = 